import React, { useState } from "react";
import api from "../../../Api/api";

function NewGroupModal({ onClose, onAddGroup }) {
  const [groupName, setGroupName] = useState('');
  const [members, setMembers] = useState([{ name: '' }]);


  //base on crud can add and delete members
  const handleFriendChange = (index, field, value) => {
    const updated = [...members];
    updated[index][field] = value;
    setMembers(updated);
  };

  const addFriendField = () => {
    setMembers([...members, { name: '' }]);
  };

  const removeFriendField = (index) => {
    const updated = members.filter((_, i) => i !== index);
    setMembers(updated);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const trimmedName = groupName.trim();
  if (!trimmedName) {
    alert("Group name cannot be empty.");
    return;
  }

  // 🪵 Log the destination and the payload being sent
  console.log("Sending to:", api.defaults.baseURL);
  console.log("Payload:", { name: trimmedName });
    try {
      // create the group
      const groupRes = await api.post('/groups/create-group', {
        name: trimmedName
        
      });
      //Use groupId if it exists in the response, otherwise use id
      const groupId = groupRes.data.groupId || groupRes.data.id;
      

      // add each members to group(that already exists in the database)
      for (const member of members.filter(m => m.name.trim() !== '')) {
        try {
        await api.post('/groups/add-user', {
          groupId,
          name: member.name.trim()
        });
        } catch (error) {
          console.error('Error adding member:', error.response?.data || error.message);
        }
      }

      alert(`✅ Group "${groupName}" created with ${members.length} member(s)!`)

      if (onAddGroup) {
        onAddGroup(); // Notify Dashboard to update SummaryCards
      }

      // Clear form
      setGroupName('');
      setMembers([{ name: '' }]); // ✅ Reset friend list
      onClose();

    } catch (error) {
        console.error('Error creating group:', error.response?.data || error.message);
      alert('Failed to create group');
    }
  };



  return (
    <form onSubmit={handleSubmit}>
      <div className="mb-3">
        <label className="form-label">
          Group Name
        </label>
        <input
          type="text"
          className="form-control"
          value={groupName}
          onChange={e => setGroupName(e.target.value)}
          required
        />
      </div>
      {/* Friend List */}
      {members.map((member, index) => (
        <div key={index} className="mb-3 border rounded p-3">
          <label className="form-label">Member {index + 1}</label>
          <input
            type="text"
            className="form-control mb-2"
            placeholder="Member Name"
            value={member.name}
            onChange={(e) => handleFriendChange(index, "name", e.target.value)}
            required
          />
          {index > 0 && (
            <button
              type="button"
              className="btn btn-danger btn-sm"
              onClick={() => removeFriendField(index)}
            >
              Remove
            </button>
          )}
        </div>
      ))}
      {/* Add Friend Button */}
      <button type="button" className="btn btn-secondary me-3" onClick={addFriendField}>
        ➕ Add Friend
      </button>
      {/* Create Group Button */}
      <button type="submit" className="btn btn-primary">Create Group</button>
    </form>
  );
}

export default NewGroupModal;